import { Outlet } from "react-router-dom";
import ru_RU from "antd/lib/locale/ru_RU";
import { ConfigProvider } from "antd";
import { ToastContainer } from "react-toastify";
import { EmbedProvider } from "./EmbedContext";
import styles from "./embed.module.scss";

/**
 * Оболочка для встраивания в ЛК Эвотор: без нижней навигации и без главного хедера приложения.
 */
export const EmbedLayout = () => {
  return (
    <EmbedProvider>
      <ConfigProvider locale={ru_RU}>
        <div className={styles.embedRoot} data-embed="true">
          <Outlet />
        </div>
        <ToastContainer position="top-center" autoClose={3000} />
      </ConfigProvider>
    </EmbedProvider>
  );
};
